import { AxiosResponse } from "axios";
import http from "config/http";
import { Response, ResponseStatus } from "core/api/definitions";

export default async (actionSlug: string): Promise<AxiosResponse<Response<ResponseStatus>>> =>
  http.get<Response<ResponseStatus>>(`/admin/dashboard/reportSubscribeByAction/${actionSlug}`);
